import React, { useMemo, useEffect, useState, useCallback } from "react";
import axios from "axios";

const GetIP = (props) => {
  //creating IP state
  const [ip, setIP] = useState('');

  //creating function to load ip address from the API
  const getData = async () => {
    const res = await axios.get('https://geolocation-db.com/json/')
    //console.log(res.data);
    setIP(res.data.IPv4)
  }
  
  useEffect( () => {
    //passing getData method to the lifecycle method
    getData()

  }, [])

  return (ip.toString());
}

export default GetIP